// Generated by purs version 0.14.3
"use strict";
var Control_Extend = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/control/v5.0.0/src/Control/Extend.purs");
var Data_Functor = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Functor.purs");
var Comonad = function (Extend0, extract) {
    this.Extend0 = Extend0;
    this.extract = extract;
};
var extract = function (dict) {
    return dict.extract;
};
module.exports = {
    Comonad: Comonad,
    extract: extract,
    Extend: Control_Extend.Extend,
    duplicate: Control_Extend.duplicate,
    extend: Control_Extend.extend,
    Functor: Data_Functor.Functor,
    map: Data_Functor.map,
    "void": Data_Functor["void"]
};
